import React, { useLayoutEffect } from "react";
import CustomFooter from "./CustomFooter";
import { useSelector } from "react-redux";
import AdminFooter from "./AdminFooter";
import LayoutProvider from "../default/LayoutProvider";
import AppRoot from "../global/AppRoot";
import AppMain from "../global/AppMain";
import Sidebar from "../default/Sidebar";
import AppWrap from "../global/AppWrap";
import AppContent from "../global/AppContent";
import Header from "../default/Header";

const MobileLayout = ({ title, content, children }) => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || ""
  );
  useLayoutEffect(() => {
    document.title = `Daily Car Wash Accounting - ${title}`;
  });
  return (
    <LayoutProvider>
      <AppRoot>
        <AppMain>
          <Sidebar />
          <AppWrap>
            <Header/>
            <AppContent content={content}>
              <div>{children}</div>
            </AppContent>
            {userRole === "admin" ? <AdminFooter /> : <CustomFooter />}
          </AppWrap>
        </AppMain>
      </AppRoot>
    </LayoutProvider>
  );
};

export default MobileLayout;
